import { api } from '../../../services/api';
import { store } from '../../../store';

export const billingApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Create a charge via OpenPay token
    createCharge: builder.mutation({
      query: (chargeData) => ({
        url: '/billing/charge',
        method: 'POST',
        body: chargeData,
      }),
      invalidatesTags: ['BillingHistory', 'PaymentMethod'],
    }),

    // Get saved payment method (masked)
    getPaymentMethod: builder.query({
      query: () => '/billing/payment-method',
      providesTags: ['PaymentMethod'],
      keepUnusedDataFor: 300,
    }),

    // Get billing history
    getBillingHistory: builder.query({
      query: () => '/billing/history',
      providesTags: ['BillingHistory'],
      keepUnusedDataFor: 60,
    }),
  }),
  overrideExisting: true,
});

export const {
  useCreateChargeMutation,
  useGetPaymentMethodQuery,
  useGetBillingHistoryQuery,
} = billingApi;

// Async helpers for imperative usage
export const createCharge = async (chargeData) => {
  return store.dispatch(billingApi.endpoints.createCharge.initiate(chargeData)).unwrap();
};

export const getPaymentMethod = async () => {
  return store.dispatch(billingApi.endpoints.getPaymentMethod.initiate()).unwrap();
};

export const getBillingHistory = async () => {
  return store.dispatch(billingApi.endpoints.getBillingHistory.initiate()).unwrap();
};
